import React from "react";

const Datepicker = ({ datepicker, handleDateChange }) => {
  const today = new Date().toISOString().split("T")[0];

  return (
    <div className="date">
      <span>{datepicker}</span>
      <div className="date-picker">
        <span></span>
        <input type="date" onChange={handleDateChange} max={today} />
      </div>
    </div>
  );
};

export default Datepicker;